import { render, staticRenderFns } from "./GroupBannerList.vue?vue&type=template&id=5f750467&scoped=true&"
import script from "./GroupBannerList.vue?vue&type=script&lang=js&"
export * from "./GroupBannerList.vue?vue&type=script&lang=js&"
import style0 from "./GroupBannerList.vue?vue&type=style&index=0&id=5f750467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f750467",
  null
  
)

export default component.exports